// var apiUrl = "https://siamroyaldurianfranchise.com:3000";
var apiUrl = "http://103.91.205.115:3000";

var options = (method, token, body) => {
    return {
        body: body ? JSON.stringify(body) : undefined,
        method: method,
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
    };
};

var getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
  }
  

var keyRandom = () => {
    return getRandomInt(1000) + "-" + new Date().getTime();
}

export default { apiUrl, options, getRandomInt, keyRandom }